import { enumToTitleCase } from '../utils/formatting';
import type { DisplayEnum } from '.';
import { convertToDisplayEnum, makeConfig } from './utils';

/**
 * BillingCalendarType defines the type of billing calendar used
 */
export type BillingCalendarType = keyof typeof billingCalendarTypeDisplayNames;

const billingCalendarTypeDisplayNames = {
  GREGORIAN: enumToTitleCase,
  BROADCAST: enumToTitleCase,
};

export const billingCalendarTypes = makeConfig<BillingCalendarType>(billingCalendarTypeDisplayNames);

/**
 * Helper function to convert BillingCalendarType enum to DisplayEnum
 */
export function convertBillingCalendarType(apiValue: string): DisplayEnum<BillingCalendarType> {
  return convertToDisplayEnum(apiValue, billingCalendarTypes);
}
